// extracted by mini-css-extract-plugin
export default {"hideTooltip":"r_-z","fadeIn":"s_-z","delay":"t_-z","recommendedSizeTooltip":"u_-z"};